import * as React from 'react';
import { Pagination } from '../Pagination';
import { jsx as _jsx } from "react/jsx-runtime";
/** Отступ для учета заголовка страницы **/
const SCROLL_OFFSET = 150;
export function PaginationContainer(_ref) {
  let {
    onPageSelect,
    page,
    lastPage,
    cardsRef
  } = _ref;
  const handleClickPagination = React.useCallback(page => {
    if (cardsRef.current) {
      const targetPosition = cardsRef.current.offsetTop;
      const offsetPosition = targetPosition - SCROLL_OFFSET;
      window.requestAnimationFrame(() => {
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      });
    }
    onPageSelect(page);
  }, [onPageSelect, cardsRef]);
  if (lastPage < 2) {
    return null;
  }
  return /*#__PURE__*/_jsx(Pagination, {
    currentPage: page,
    lastPage: lastPage,
    onClick: handleClickPagination
  });
}